import React, { useMemo } from 'react'
import { NavLink, matchPath, useLocation } from 'react-router-dom'

import { Icon, Tag } from '@fourthwall/components'
import { routing } from '@utils/routing'

import * as S from './styled'
import type { DashboardMenuItemProps } from './types'

export const DashboardMenuItem = ({
  label,
  icon,
  activeIcon,
  rightIcon,
  tag,
  to,
  as = NavLink,
  children,
  onClick,
}: DashboardMenuItemProps) => {
  const location = useLocation()
  const matched = useMemo(() => {
    return !!matchPath({ path: String(to), end: to === routing.home }, location.pathname)
  }, [location, to])

  const renderIcon = () => {
    if (!icon) return <div style={{ width: 16 }} />

    return <Icon component={matched && activeIcon ? activeIcon : icon} height={16} />
  }

  return (
    <S.Container onClick={onClick}>
      {to ? (
        <S.Link as={as} to={to} href={as === 'a' ? to : undefined} $active={matched && !children}>
          <S.Wrapper>
            {renderIcon()}
            <S.Label>{label}</S.Label>
            {rightIcon}
            {tag && (
              <S.TagWrapper>
                <Tag label={tag} />
              </S.TagWrapper>
            )}
          </S.Wrapper>
        </S.Link>
      ) : (
        <S.Button type="button">
          <S.Wrapper>
            {icon ? <Icon component={icon} height={16} /> : <div style={{ width: 16 }} />}
            <S.Label>{label}</S.Label>
            {rightIcon}
            {tag && (
              <S.TagWrapper>
                <Tag label={tag} />
              </S.TagWrapper>
            )}
          </S.Wrapper>
        </S.Button>
      )}
      {children}
    </S.Container>
  )
}
